import moment from 'moment';

// Match the Monday-first grid used by calendarViews, independent of the UI locale.
export default function calendarDateRange(date, view) {
  const selected = moment(date);
  let start = selected.clone().startOf('isoWeek');
  let end = start.clone().add(6, 'days');
  if (view === 'day') {
    start = selected.clone();
    end = selected.clone();
  } else if (view === 'month') {
    start = selected.clone().startOf('month').startOf('isoWeek');
    end = selected.clone().endOf('month').endOf('isoWeek');
  } else if (view === 'week5' || view === 'week6') {
    end = start.clone().add(view === 'week5' ? 4 : 5, 'days');
  }
  return { fromDate: start.format('YYYY-MM-DD'), toDate: end.format('YYYY-MM-DD') };
}
